export enum ScribeLiveFallbacks {
  NotFoundScreenshot = 'Refer to the screenshot, then click “Next” to continue.',
  NotFoundStep = 'Refer to the step, then click “Next” to continue.',
  UrlMismatch = 'Looks like you’re on a different page.',
}
